(() => {
  if (window.mdCustomerHelpLoaded) return;
  window.mdCustomerHelpLoaded = true;
  let activeDialog, returnFocus, restoreFocus = true;
  const status = (dialog, message) => { dialog.querySelector('[data-md-help-status]').textContent = message; };
  const close = () => { if (activeDialog?.open) activeDialog.close(); };
  document.addEventListener('click', async event => {
    const trigger = event.target.closest('[data-md-help-open]');
    if (trigger) {
      const dialog = document.getElementById(trigger.getAttribute('aria-controls'));
      if (!dialog) return;
      event.preventDefault();
      event.stopPropagation();
      close();
      returnFocus = trigger;
      restoreFocus = true;
      // Release the drawer's focus trap before opening the native modal.
      const drawer = document.querySelector('header-drawer');
      const details = drawer?.querySelector('details');
      if (details?.open) {
        const summary = details.querySelector('summary');
        drawer.closeMenuDrawer(event, summary);
        summary.setAttribute('aria-expanded', 'false');
        returnFocus = summary;
      }
      activeDialog = dialog;
      status(dialog, '');
      dialog.querySelectorAll('[data-md-copy-email]').forEach(button => button.setAttribute('aria-label','Copy support email'));
      dialog.showModal();
      document.body.classList.add('md-help-open');
      dialog.addEventListener('close', () => {
        document.body.classList.remove('md-help-open');
        if (restoreFocus) returnFocus?.focus({preventScroll:true});
        activeDialog = null;
      }, {once:true});
      return;
    }
    const dialog = event.target.closest('[data-md-help-dialog]');
    if (!dialog) return;
    if (event.target.closest('[data-md-help-close]')) { close(); return; }
    if (event.target === dialog) {
      const box = dialog.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) close();
      return;
    }
    const copy = event.target.closest('[data-md-copy-email]');
    if (copy) {
      try {
        await navigator.clipboard.writeText(copy.dataset.mdCopyEmail);
        status(dialog, 'Email copied!');
        copy.setAttribute('aria-label', 'Support email copied');
      } catch (_) { status(dialog, 'Could not copy automatically. Press and hold the email to copy it, or tap it to send a message.'); }
      return;
    }
    if (event.target.closest('[data-md-help-chat]')) {
      const launcher = document.querySelector('button.kl-hub-launcher');
      if (!launcher) { status(dialog, 'Chat is still loading. Please try again shortly, or email our team.'); return; }
      restoreFocus = false;
      close();
      if (launcher.getAttribute('aria-expanded') !== 'true') launcher.click();
    }
  }, true);
  document.addEventListener('shopify:section:unload', event => {
    if (activeDialog && event.target.contains(activeDialog)) close();
  });
})();
